/* ---------------------------------------------------------------------------
 * MD Fashionwear — keep the free shipping bar honest
 *
 * WHY IT NEEDS SCRIPTING AT ALL
 * The bar is rendered server-side, so it only reflected the cart as it was when
 * the page loaded. Change a quantity with the +/- stepper and it did not move: a
 * cart knocked down to 160 still announced "You have earned free shipping", which
 * promises something checkout will not honour.
 *
 * NO MUTATION OBSERVER HERE — THIS IS DELIBERATE, DO NOT ADD ONE BACK.
 * An earlier version watched the document for added nodes. Writing textContent
 * CREATES a text node, so every repaint retriggered the observer, which fetched
 * the cart and repainted again: an endless loop that froze the browser tab.
 *
 * Instead: repaint on cart events, plus a cheap poll that only looks for a
 * data-painted marker. Fresh server markup has no marker, so a re-rendered drawer
 * is picked up within a second without any DOM watching.
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  var busy = false;

  function fmt(cents) {
    if (window.MDCartSync && window.MDCartSync.fmt) return window.MDCartSync.fmt(cents);
    var amount = (Number(cents) || 0) / 100;
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return amount.toFixed(2) + (code ? ' ' + code : '');
  }

  function paint(bar, cart) {
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
    if (isNaN(threshold) || threshold <= 0) return;

    var msgEl = bar.querySelector('.md-ship-bar__msg');
    var fillEl = bar.querySelector('.md-ship-bar__fill');
    var scaleEl = bar.querySelector('.md-ship-bar__scale');
    var spentEl = bar.querySelector('.md-ship-bar__spent');
    var targetEl = bar.querySelector('.md-ship-bar__target');

    // Only shippable lines count, matching how Shopify decides and how the
    // Liquid that first rendered this bar calculated it.
    var spent = 0;
    (cart.items || []).forEach(function (i) {
      if (i.requires_shipping) spent += i.final_line_price;
    });

    var remaining = threshold - spent;
    var reached = remaining <= 0;
    var pct = Math.max(0, Math.min(100, Math.round(spent * 100 / threshold)));

    bar.classList.toggle('md-ship-bar--reached', reached);
    if (fillEl) fillEl.style.width = pct + '%';

    if (msgEl) {
      if (reached) {
        msgEl.textContent = bar.getAttribute('data-reached') || 'You have earned free shipping.';
      } else {
        msgEl.innerHTML = 'You&rsquo;re <strong></strong> away from FREE shipping!';
        var strong = msgEl.querySelector('strong');
        if (strong) strong.textContent = fmt(remaining);
      }
    }

    if (scaleEl) scaleEl.hidden = reached;
    if (spentEl) spentEl.textContent = fmt(spent);
    if (targetEl) targetEl.textContent = fmt(threshold);

    bar.setAttribute('data-painted', String(spent) + '|' + String(threshold));
  }

  function run(force) {
    var bar = document.querySelector('.md-ship-bar');
    if (!bar || busy) return;
    if (!force && bar.hasAttribute('data-painted')) return;

    busy = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart) paint(bar, cart); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function boot() {
    run(true);

    var force = function () { run(true); };
    document.documentElement.addEventListener('cart:refresh', force);
    document.documentElement.addEventListener('cart:change', force);
    document.addEventListener('cart:change', force);
    document.addEventListener('variant:add', force);

    // Cheap: only reads an attribute. Catches server-rendered markup, which
    // arrives without the marker.
    setInterval(function () { run(false); }, 900);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.MDCartBar = { refresh: function () { run(true); } };
})();
